export const columnHTML = `
  <b>Colunas Convencionais</b>
  Colunas com transformações, De-Para, Tipo e Tamanho.
  <br>
  <br>
  <b>Colunas Virtuais</b>
  Colunas com Nome e Função ( disponível apenas em Layouts do tipo
  <b>ENVIO</b> ).
  <br>
  <br>
  <b>Colunas Complementares</b>
  Possui os mesmos campos que as <b>Colunas Convencionais</b>, mas
  o De-Para é realizado entre uma Coluna convencional e um campo do
  banco de dados ( disponível apenas em Layouts do tipo
  <b>RECEBIMENTO</b> ).
`;

export const advanceComplementaryMessage = `
  Para configurar este tipo de coluna, clique em <b>Avançar</b>
  e prossiga para a sessão <b>Colunas Complementares</b>.
`;

export const advanceVirtualMessage = `
  Para configurar a coluna Função, clique em <b>Avançar</b>
  e configure a função na sessão <b>Colunas Virtuais</b>.
`;

export const complementaryColumnHTML = `
  <b>Colunas Complementares</b>
  <br>
  <br>
  Possui os mesmos campos que as <b>Colunas Convencionais</b>,
  mas o De-Para é realizado entre uma Coluna Convencional
  e um campo do banco de dados
  ( disponível apenas em Layouts do tipo <b>RECEBIMENTO</b> ).
`;

export const complementaryConfigurationColumnHTML = `
  ${complementaryColumnHTML}
  <br>
  <br>
  ${advanceComplementaryMessage}
`;

export const virtualColumnHTML = `
  <b>Colunas Virtuais</b>
  <br>
  <br>
  Colunas com os campos Nome e Função
  ( disponível apenas em Layouts do tipo <b>ENVIO</b> ).
`;

export const virtualConfigurationColumnHTML = `
  ${virtualColumnHTML}
  <br>
  <br>
  ${advanceVirtualMessage}
`;

export const typeIntegrationValueUpdated = `
  Tudo certo! Mesmo que você tenha avançado, ainda pode
  cancelar a alteração do layout e manter suas configurações atuais.
  <br>
  <br>
  Para isso, use os botões no canto inferior da tela:
  <br>
  <br>
  <b>VOLTAR</b>: retorna à tela inicial do Layout de Importação.<br>
  <b>CANCELAR</b>: leva você de volta ao Menu Inicial.
`;

export function typeIntegrationValueConfirmation(columnTypeToBeRemoved) {
  return `
    Ao alterar o tipo de Integração, as colunas do tipo
    <b>${columnTypeToBeRemoved}</b> serão removidas.
    <br>
    <br>
    Tem certeza que deseja prosseguir?
  `;
}
